import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  TargetTemplateItem,
  TargetTemplatesResponse,
} from "@/actions/ssr/target/getTargetTemplatesSSR";

interface TargetTemplatesState {
  items: TargetTemplateItem[];
  count: number;
  total_pages: number;
  current_page: number;
}

const initialState: TargetTemplatesState = {
  items: [],
  count: 0,
  total_pages: 1,
  current_page: 1,
};

const targetTemplatesSlice = createSlice({
  name: "targetTemplates",
  initialState,
  reducers: {
    setTargetTemplates(state, action: PayloadAction<TargetTemplatesResponse>) {
      state.items = action.payload.results;
      state.count = action.payload.count;
      state.total_pages = action.payload.total_pages;
      state.current_page = action.payload.current_page;
    },
    removeTargetTemplate(state, action: PayloadAction<string>) {
      state.items = state.items.filter((t) => t.id !== action.payload);
      state.count = Math.max(0, state.count - 1);
    },
    addTargetTemplate(state, action: PayloadAction<TargetTemplateItem>) {
      state.items = [...state.items, action.payload];
      state.count += 1;
    },
    updateTargetTemplate(state, action: PayloadAction<TargetTemplateItem>) {
      state.items = state.items.map((t) =>
        t.id === action.payload.id ? action.payload : t,
      );
    },
  },
});

export const {
  setTargetTemplates,
  removeTargetTemplate,
  addTargetTemplate,
  updateTargetTemplate,
} = targetTemplatesSlice.actions;
export default targetTemplatesSlice.reducer;
